<template>
    <div class="app-modal-dialog--publication-share-overlay app-modal-dialog modal is--xl" tabindex="-1" role="dialog">
        <div class="app-modal-dialog__content">
            <div class="app-modal-dialog__header">
                <h4 class="app-modal-dialog__title">Share Review Links</h4>
            </div>
            <div class="app-modal-dialog__body grid">
                <p class="col-12">Review links allow users without Builder login credentials to review Builder-created courses via custom url. Locking the link ensures that changes made to the course after the Lock button is selected are not reflected in the review link until the Unlock button is selected. Review links remain active for 30 days upon creation. The Reset Expiration button resets the link expiration for 30 days upon selection. Turning Issue Tracker on makes the Issue Tracker pop-up to follow users through the course, so they can note any issues for the project in real time.</p>
                <public-review-generate ref="manager"
                    :publication="publicationData"
                    :project="project"
                    :issuetracker-url="issuetrackerUrl"
                    :is-lite-mode="true"
                    :enable-settings="false"
                    :enable-title="false"
                    class="app-public-review-generate--lite col-12"
                    @cancel="cancel()">
                </public-review-generate>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        source: {
            type: Object,
            default: () => ({
                id: 'new-publication',
                name: '',
                description: '',
                options: {},
            })
        },
        publication: {
            type: Object,
        },
        project: {
            type: Object,
            default: () => ({}),
        },
        issuetrackerUrl: {
            type: String,
            default: null
        },
    },
    data () {
        return {
            themeTemplate: 0,
            publicationData: this.publication,
            isIssutrackerLinked: this.issuetrackerUrl && this.project?.settings?.issuetracker,
            disabled: false,
            selectedOptions: {},
            selectedDefaults: {},
        }
    },
    computed: {
        requirementsMet() {
            return this.publicationData.name.length
        },
        hasChanges() {
            return !_.isEqual(this.selectedOptions, this.savedOptions)
        },
        locales: state => state.project?.locales ?? [],
        hasLocales() {
            return this.locales.length > 0
        },
    },
    methods: {
        cancel () {
            this.$emit('cancel')
        },
    },
    mounted() {
        console.log('mounted themeTemplate', this.themeTemplate, this.options, this.selectedDefaults, this.savedOptions, this.selectedOptions)
    },
    watch: {
        publication: {
            handler(newVal) {
                 this.publicationData = _.merge({}, this.publicationData, newVal)
            },
            immediate: true,
        },
    }
}
</script>
